export const TO_ASSIGN = 'TO_ASSIGN'
export const ACTIVE = 'ACTIVE'
export const SCHEDULED = 'SCHEDULED'
export const ON_SITE = 'ON_SITE'
export const CONTRACTS = 'CONTRACTS'
export const ACQUIRED = 'ACQUIRED'
export const INACTIVE = 'INACTIVE'
export const DESKLOG = 'DESKLOG'
export const F_AND_I = 'F_AND_I'

export const LEAD_STATUSES = {
  TO_ASSIGN,
  ACTIVE,
  SCHEDULED,
  ON_SITE,
  CONTRACTS,
  ACQUIRED,
  INACTIVE,
  DESKLOG,
  F_AND_I,
}

export interface LeadStatusOption {
  key: 'TO_ASSIGN' | 'ACTIVE' | 'SCHEDULED' | 'ON_SITE' | 'CONTRACTS' | 'ACQUIRED' | 'INACTIVE'
  name: string
  colorClass: string
}

export const options: LeadStatusOption[] = [
  {
    key: TO_ASSIGN,
    name: 'To assign',
    colorClass: '#A7A6A1',
  },
  {
    key: ACTIVE,
    name: 'Active',
    colorClass: '#FEF2DD',
  },
  {
    key: SCHEDULED,
    name: 'Scheduled',
    colorClass: '#FBD38E',
  },
  {
    key: ON_SITE,
    name: 'On site',
    colorClass: '#DAFAD9',
  },
  {
    key: CONTRACTS,
    name: 'Contracts',
    colorClass: '#F9BE58',
  },
  {
    key: ACQUIRED,
    name: 'Sold',
    colorClass: '#82CF80',
  },
  {
    key: INACTIVE,
    name: 'Inactive',
    colorClass: '#f7f7f6',
  },
]
